import React, { Component } from 'react';
import { Button, DatePicker, Modal, Select, Spin } from 'antd';
import download from 'downloadjs';
import _ from 'lodash';

import * as leadController from '../../../../../../services/api/lead';
import { leadTypeOptions, leadSourceOptions, leadStatusOptions } from '../../../../../../utils/options';
import './LeadExportModal.scss';

const { RangePicker } = DatePicker;
const { Option } = Select;

export default class LeadExportModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            selectedDateRange: [],
            selectedSource: undefined,
            selectedType: undefined,
            selecetdStatus: undefined
        }
    }

    handleSubmit() {
        const { selectedDateRange, selectedType, selectedSource, selecetdStatus } = this.state;

        this.setState({ isLoading: true });
        leadController.exportLeads({
                source: selectedSource,
                type: selectedType,
                status: selecetdStatus,
                since: selectedDateRange[0] && selectedDateRange[0].startOf('day').toISOString(),
                until: selectedDateRange[1] && selectedDateRange[1].endOf('day').toISOString()
            })
            .then((res) => res.blob())
            .then((blob) => {
                this.setState({ isLoading: false });

                download(blob, 'leads.csv');
            })
    }

    render() {
        const { visible, onCancel } = this.props;
        const { selectedDateRange, selectedType, selectedSource, selecetdStatus, isLoading } = this.state;
        const leadSourceOptionComponents = _.map(leadSourceOptions, (item) => <Option key={item} value={item}>{item}</Option>);
        const leadTypeOptionComponents = _.map(leadTypeOptions, (item) => <Option key={item} value={item}>{item}</Option>);
        const leadStatusOptionComponents = _.map(leadStatusOptions, (item) => <Option key={item} value={item}>{item}</Option>);

        return (
            <Modal
                width="60%"
                style={{ pointerEvents: isLoading ? 'none' : ''}}
                maskClosable={!isLoading}
                wrapClassName="LeadExportModal"
                visible={visible}
                footer={null}
                onCancel={onCancel}
            >
            	<Spin spinning={isLoading} tip="Exporting...This process may take a while">
	                <p className="label">Select the query to export leads:</p>
	                <div className="query-bar">
	                	<div className="query-option">
	                    	<label>Select Range: </label>
	                        <RangePicker
	                            value={selectedDateRange}
	                            onChange={(dates, dateStrings) => this.setState({ selectedDateRange: dates })}
	                        />
	                    </div>
	                </div>
	                <div className="query-bar">
	                    <div className="query-option">
	                        <label>Lead Source: </label>
	                        <Select
	                            allowClear
	                            style={{ width: 200 }}
	                            placeholder="(All)"
	                            vallue={selectedSource}
	                            onChange={(value) => this.setState({ selectedSource: value })}
	                        >
	                            {leadSourceOptionComponents}
	                        </Select>
	                    </div>
	                    {" "}
	                    <div className="query-option">
	                        <label>Lead Type: </label>
	                        <Select
	                            allowClear
	                            style={{ width: 200 }}
	                            placeholder="(All)"
	                            vallue={selectedType}
	                            onChange={(value) => this.setState({ selectedType: value })}
	                        >
	                            {leadTypeOptionComponents}
	                        </Select>
	                    </div>
	                    {" "}
	                    <div className="query-option">
	                        <label>Lead Status: </label>
	                        <Select
	                            allowClear
	                            style={{ width: 200 }}
	                            placeholder="(All)"
	                            vallue={selecetdStatus}
	                            onChange={(value) => this.setState({ selecetdStatus: value })}
	                        >
	                            {leadStatusOptionComponents}
	                        </Select>
	                    </div>

	                </div>
	                <div className="footer">
	                    <Button type="primary" size="large" onClick={(e) => this.handleSubmit()}>Export</Button>
	                </div>
                </Spin>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/LeadPage/components/LeadExportModal/LeadExportModal.js